import React, { useState, useEffect, useContext } from "react";
import ReactApexChart from "react-apexcharts";
import Chart from "react-apexcharts";
import DataContext from "../../../utils/Context/DataContext";
import { Link, useParams } from "react-router-dom";
import { api } from "../../../utils/Api";

export default function OutletDashboard(props: any) {
  const context = useContext(DataContext);
  const [id_value, SerIdValue] = useState(useParams());
  const [dashboard_data, SetDashboardData] = useState({});
  const [series, SetSeries] = useState([55, 44, 11]);
  const [value, SetValue] = useState({
    labels: ["Total", "delivered", "Pending"],
    chart: {
      width: 380,
      type: "donut",
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "gradient",
      colors: ["#F44336", "#E91E63", "#9C27B0"],
    },
    markers: {
      colors: ["#F44336", "#E91E63", "#9C27B0"],
    },
    colors: [
      function ({ value, seriesIndex, w }) {
        if (value < 55) {
          return "#7E36AF";
        } else {
          return "#D9534F";
        }
      },
      function ({ value, seriesIndex, w }) {
        if (value < 111) {
          return "#E91E63";
        } else {
          return "#9C27B0";
        }
      },
    ],
    legend: {
      formatter: function (val: any, opts: any) {
        return val + " - " + opts.w.globals.series[opts.seriesIndex];
      },
    },
    title: {
      text: "Project Details",
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            width: 300,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });
  const [lineseries, SetLineSeries] = useState([
    {
      name: "Sales",
      data: [5000, 8000, 10000, 25000, 40000, 50000, 100000],
    },
  ]);
  const [lineoptions, SetLineOptions] = useState({
    chart: {
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    title: {
      text: "Salary Details",
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      // max: 100,
      count: 12,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        gradientToColors: ["#0267ff"],
        // shadeIntensity: 1,
        type: "horizontal",
        // opacityFrom: 1,
        // opacityTo: 1,
        stops: [0, 100, 100, 100],
      },
    },
    stroke: {
      curve: "smooth",
    },

    markers: {
      size: 0,
    },
  });

  useEffect(() => {
    console.log("OutletDashboard On mount :", props);
    console.log("OutletDashboard context :", context);
    get_dashborad();
  }, []);

  async function get_dashborad() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        // company_id: id_value.company_id,
      },
    };
    let data = await api("/outlet/dashboard", pass_data);
    console.log("Outlet dashboard response :", data.response);
    if (data.response.hasOwnProperty("statistics")) {
      SetDashboardData(data.response.statistics);
    }
    console.log("Statistic response 1:", dashboard_data);
    console.log("Statistic response 2:", data.response.statistics);
  }

  function title_generate(title: any) {
    let replaced_data = title.replaceAll("_", " ");
    var splitStr = replaced_data.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }

  return (
    <div>
      <div className="bg-fff py-2 px-4 d-flex">
        <div>
          <h5 className="  mb-1">Outlet Dashboard</h5>
          <small>Photos, Videos, Documents</small>
        </div>
        {/* <Link
          to={
            "/outlet/" +
            id_value.brand_id +
            "/" +
            id_value.outlet_id +
            "/order_request/all"
          }
        >
          <button className="btn btn-light-outline ms-auto">
            Order Request
          </button>
        </Link> */}
      </div>

      <div className="container py-3">
        <div className="row">
          {Object.keys(dashboard_data).map((key: any, index: any) => (
            <div className="col-6 col-md-4 col-lg-2" key={index}>
              <div className="card c-shadow p-3 mb-3">
                <p className="pheight">
                  <b className="text-dark fs-7 fw-bolder">
                    {title_generate(key)}
                  </b>
                </p>

                {/* <div className="d-flex"> */}
                <small className="text-gray fw-bolder">
                  {dashboard_data[key]}
                </small>
                {/* <div className="ms-auto">
                    {dashboard_data.total_orders_amount != "" || dashboard_data.total_orders_paid_amount != "" ? (
                      <img src={require("../../../assets/img/chart-up.png")} className="action_img" />
                    ) : (null)}
                    {dashboard_data.total_orders_pending_amount != "" ? (
                      <img src={require("../../../assets/img/chart-down.png")} className="action_img " />
                    ) : (null)}

                  </div> */}
                {/* </div> */}
              </div>
            </div>
          ))}
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-4 mb-2">
                <div className="card p-3">
                  <div className="d-flex">
                    <img
                      src={require("../../../assets/img/folders.png")}
                      className="w-15"
                    />
                    <div
                      className="ms-auto"
                      onClick={() => {
                        console.log("menu");
                      }}
                    >
                      <i
                        className="fas fa-ellipsis-v cursor"
                        style={{ color: "gray" }}
                      ></i>
                    </div>
                  </div>
                  <div className="mt-3">
                    <h6>Images</h6>
                    <small className="v-small">4500</small>
                    <div className="d-flex mt-1 align-items-center">
                      <p className="m-0">
                        <small className="text-dark">25%</small>
                      </p>
                      <small className="v-small ms-auto">5 Days ago</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-2">
                <div className="card p-3">
                  <div className="d-flex">
                    <img
                      src={require("../../../assets/img/folders.png")}
                      className="w-15"
                    />
                    <div
                      className="ms-auto"
                      onClick={() => {
                        console.log("menu");
                      }}
                    >
                      <i
                        className="fas fa-ellipsis-v cursor"
                        style={{ color: "gray" }}
                      ></i>
                    </div>
                  </div>
                  <div className="mt-3">
                    <h6>Audio</h6>
                    <small className="v-small">4500</small>
                    <div className="d-flex mt-1 align-items-center">
                      <p className="m-0">
                        <small className="text-dark">25%</small>
                      </p>
                      <small className="v-small ms-auto">5 Days ago</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-2">
                <div className="card p-3">
                  <div className="d-flex">
                    <img
                      src={require("../../../assets/img/folders.png")}
                      className="w-15"
                    />
                    <div
                      className="ms-auto"
                      onClick={() => {
                        console.log("menu");
                      }}
                    >
                      <i
                        className="fas fa-ellipsis-v cursor"
                        style={{ color: "gray" }}
                      ></i>
                    </div>
                  </div>
                  <div className="mt-3">
                    <h6>Video</h6>
                    <small className="v-small">4500</small>
                    <div className="d-flex mt-1 align-items-center">
                      <p className="m-0">
                        <small className="text-dark">25%</small>
                      </p>
                      <small className="v-small ms-auto">5 Days ago</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-3 mt-3">
              <div id="linechart">
                <Chart
                  options={lineoptions}
                  series={lineseries}
                  type="line"
                  curve="smooth"
                  height={350}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card p-2 pt-3">
              <div id="chart">
                <ReactApexChart
                  options={value}
                  series={series}
                  type="donut"
                  width={300}
                />
              </div>

              <div className="row pt-2">
                <div className="col-6 text-center">
                  <h6>Total Projects</h6>
                  <p>
                    <small className="text-dark">1025</small>
                  </p>
                </div>
                <div className="col-6 text-center">
                  <h6>Delivered Projects</h6>
                  <p>
                    <small className="text-dark">1015</small>
                  </p>
                </div>
              </div>
            </div>
            <div className="pt-4">
              <h5 className="  mb-0">
                <b>Recent Orders</b>
              </h5>
              <small className="text-gray">Project reports</small>
              <div className="card mt-3 p-3">
                <div className="row align-items-center">
                  <img
                    src={require("../../../assets/img/folders.png")}
                    className="col-2"
                  />
                  <div className="col-8">
                    <h6 className="mb-0">videos</h6>
                    <small className="text-dark">3 files</small>
                  </div>
                  <div className="col-2 text-end">
                    <i
                      className="fas fa-ellipsis-v cursor"
                      style={{ color: "gray" }}
                    ></i>
                  </div>
                </div>
              </div>

              <div className="card mt-3 p-3">
                <div className="row align-items-center">
                  <img
                    src={require("../../../assets/img/folders.png")}
                    className="col-2"
                  />
                  <div className="col-8">
                    <h6 className="mb-0">Images</h6>
                    <small className="text-dark">150 files</small>
                  </div>
                  <div className="col-2 text-end">
                    <i
                      className="fas fa-ellipsis-v cursor"
                      style={{ color: "gray" }}
                    ></i>
                  </div>
                </div>
              </div>

              <div className="card mt-3 p-3">
                <div className="row align-items-center">
                  <img
                    src={require("../../../assets/img/folders.png")}
                    className="col-2"
                  />
                  <div className="col-8">
                    <h6 className="mb-0">audio</h6>
                    <small className="text-dark">3 files</small>
                  </div>
                  <div className="col-2 text-end">
                    <i
                      className="fas fa-ellipsis-v cursor"
                      style={{ color: "gray" }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
